export const BRAND_SCHEDULE_SETTINGS_TAB = {
  SESSION_GROUPS: { id: 1, path: 'session-groups' },
} as const
